import { constants as config } from '@config';

module.exports = {
  placeHolderUrl: 'https://static.inkive.com/assets/img/placeholders/imageplaceholder_new.svg',

  mapResult: function (item) {
    this.canvas = INKIVE.Tool.getInstance().editor.canvas;

    const photos = item.publiclyVisibleRedfinListingPhotos || [];
    const thumbnail = item['agent.agentHeroPhotoUrl'];

    if (thumbnail) {
      photos.unshift({
        id: 'agentThumbnail',
        midSizeImageUrl: thumbnail,
        fullSizeImageUrl: thumbnail
      });
    }

    this.item = {
      id: item.id,
      thumbnail: thumbnail || photos.length
        ? photos[0].midSizeImageUrl
        : this.placeHolderUrl,

      list_key: item.id,
      list_uuid: item.list_uuid,
      address: item['property.address.streetString'],
      city: item['property.address.city'],
      state: item['property.address.stateOrProvinceCode'],
      postal_code: item['property.address.postalCode'],

      photos,
      text: {
        list_key: item.id,
        statement: item['agent.agentStatement'],
        average_rating: item['agent.averageRating'],
        license_number: item['agent.licenseNumber'],
        is_principal_agent: item['agent.isPrincipalAgent'],
        homes_sold: item['agent.numberOfHomesSold'],
        office_address: item['agent.officeAddress.streetLine'],
        office_city: item['agent.officeAddress.city'],
        office_postal_code: item['agent.officeAddress.postalCode'],
        office_state_or_province: item['agent.officeAddress.stateOrProvinceCode'],
        office_phone_number: item['agent.officePhone.phoneNumber'],
        agent_title: item['agent.publicAgentTitle'],
        agent_first_name: item['agent.redfinAccountProfile.firstName'],
        agent_display_name: item['agent.redfinAccountProfile.displayName'],
        agent_email: item['agent.redfinAccountProfile.email'],
        agent_total_sales_in_past_year: this.getPrice(item['agent.totalSalesInDollarsInThePastYear']),
        listing_days_on_market: item.redfinListingDaysOnMarket,
        listing_price: this.getPrice(item['listing.listingPricing.listingPrice.value']),
        property_address: item['property.address.streetString'],
        property_address_no_state_or_zipcode: item['property.address.fullDisplayStringNoStateOrZipCodePretty'],
        property_address_full_no_zipcode: item['property.address.fullDisplayStringNoZipCodePretty'],
        property_postal_code: item['property.address.postalCode'],
        property_city_and_state: item['property.address.cityString'],
        property_state_or_province: item['property.address.stateOrProvinceCode'],
        property_city: item['property.address.city'],
        number_of_bathrooms: item['property.numBathrooms'],
        number_of_bedrooms: item['property.numBedrooms'],
        number_of_total_sq_feet: item['property.totalSqFt']
      }
    };

    return this.item;
  },

  getPrice: function (attribute) {
    return '$' + Number(attribute).toLocaleString();
  },

  showPropertyImages: function ($container, parent) {
    const deferred = $.Deferred();
    const photos = this.item.photos;

    $container.append('<div class="thumbnail-wrapper"/>');

    if (!photos.length) {
      $container.html('<label class="title text-center">' +
        INKIVE.TranslateHelper.translate('general.no_results') +
        '</label>');
    }

    const callback = function (thumb, $wrapper) {
      INKIVE.Modal.loaderClose($container);
      _.bind(parent.tool.callbackImages, parent.tool)(thumb, $wrapper);

      $(thumb).each(function () {
        const $thumb = $(this);
        $thumb.attr('data-search-filter', $thumb.find('a').attr('data-original-title'));
      });

      $wrapper.find('.thumbnail-wrapper').masonry(config.sidebar.thumbnail.masonryConfig);
      parent.refreshAntiscroll();
    };

    const thumbs = _.map(photos, function (photo) {
      INKIVE.ImagesFactory.addImageData(photo.fullSizeImageUrl);

      return {
        id: 'photo-redfin-details-' + photo.id,
        width: 120,
        data: {
          version: {
            thumb: photo.midSizeImageUrl,
            original: photo.fullSizeImageUrl
          }
        }
      };
    });

    parent.tool.addThumbItem($container, thumbs, callback);

    return deferred.promise();
  },

  showPropertyTexts: function ($container, parent) {
    const showReplaceButton = $(this.getSelectedElement()).is('.textarea');
    const onlyReplace = parent.canUseText === 'onlyReplace';

    INKIVE.Modal.loaderClose($container);
    _.each(this.item.text, _.bind(function (text, key) {
      if (text) {
        key = key.replace(/_/g, ' ');
        text = (text + '').replace(/"/g, '&quot;');

        const $textThumbContainer = $('<div class="thumbnail-wrapper no-resizable" ' +
          'data-search-filter="' + text.toLowerCase() + key + '"/>');

        const thumb = new INKIVE.ThumbText({
          text,
          width: 230,
          fontFamily: 'Lato'
        });
        const replaceText = _.bind(_.partial(this.onReplaceText, thumb), this);

        thumb.appendTo($textThumbContainer);

        const $button = $('<div class="description">' + key + '</div>' +
          '<div class="icons">' + (onlyReplace
          ? ''
          : '<i class="desygner-icon-plus add-text stand-alone"/>') +
          '<i class="fa fa-refresh replace-text ' + (showReplaceButton
          ? ''
          : 'hidden') + '"/>' +
          '</div>');

        $textThumbContainer.append($button);

        $textThumbContainer.appendTo($container);
        $textThumbContainer.find('i.desygner-icon-plus').on('click', _.bind(thumb.onItemClick, thumb));
        $textThumbContainer.find('i.replace-text').on('click', replaceText);

        onlyReplace && $textThumbContainer.find('.thumbnail').off('mousedown').on('click', replaceText);
      }
    }, this), parent);

    parent.refreshAntiscroll();
  },

  onReplaceText: function (thumb) {
    const element = this.getSelectedElement();

    if ($(element).is(':not(.textarea)')) {
      return;
    }
    const textarea = new INKIVE.Text.Textarea().setDOM(element);

    textarea.text.setValues({ textContent: thumb.text });
    textarea.render(this.canvas);
  },

  getSelectedElement: function () {
    const elems = this.canvas.getSelectedElems();

    return elems.length && elems[0];
  }
};
